 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"app": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"app": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({"alignmentWizard~printPreview":"alignmentWizard~printPreview","alignmentWizard":"alignmentWizard","printPreview":"printPreview","background":"background","clipArt":"clipArt","colorPickr":"colorPickr","confirmBack":"confirmBack","contact":"contact","customLabelSizes":"customLabelSizes","forgotPassword":"forgotPassword","guideLines":"guideLines","help":"help","labelMaterials":"labelMaterials","labelShapes":"labelShapes","labelSizes":"labelSizes","layout":"layout","leftRuler":"leftRuler","loginModal":"loginModal","mismatched":"mismatched","nameAndContinue":"nameAndContinue","printOptions":"printOptions","printingCompleted":"printingCompleted","printingHelp":"printingHelp","rotate":"rotate","saveConfirmation":"saveConfirmation","saveLabel":"saveLabel","saveTemplate":"saveTemplate","settings":"settings","shapes":"shapes","shiftedVertical":"shiftedVertical","smallPage":"smallPage","textTool":"textTool","topRuler":"topRuler","troubleShooting":"troubleShooting","uploadArt":"uploadArt"}[chunkId]||chunkId) + "." + {"alignmentWizard~printPreview":"8f34fcf4","alignmentWizard":"56cfe0f3","printPreview":"1e2c387a","background":"fee0d393","clipArt":"d875ca1d","colorPickr":"e1f9a33c","confirmBack":"8bd839c9","contact":"b6d8f668","customLabelSizes":"9c1ffecb","forgotPassword":"a0bdd004","guideLines":"1ddf01e8","help":"306dc01a","labelMaterials":"c863d20e","labelShapes":"18179ef6","labelSizes":"1e71fd55","layout":"3fe5ddb1","leftRuler":"e9df5318","loginModal":"f50588fa","mismatched":"41bd4cea","nameAndContinue":"1c4e6d66","printOptions":"2e5867ee","printingCompleted":"f4b65d69","printingHelp":"8eb90e11","rotate":"255676d3","saveConfirmation":"d241747e","saveLabel":"100a1457","saveTemplate":"aaea103c","settings":"996ba4c5","shapes":"b99ca9b7","shiftedVertical":"e15472f7","smallPage":"153ac577","textTool":"ec2d0177","topRuler":"5b11a36c","troubleShooting":"6e4565bb","uploadArt":"93923ac4"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"alignmentWizard":1,"printPreview":1,"background":1,"clipArt":1,"colorPickr":1,"confirmBack":1,"contact":1,"customLabelSizes":1,"forgotPassword":1,"guideLines":1,"help":1,"labelMaterials":1,"labelShapes":1,"labelSizes":1,"layout":1,"leftRuler":1,"loginModal":1,"mismatched":1,"nameAndContinue":1,"printOptions":1,"printingCompleted":1,"printingHelp":1,"rotate":1,"saveConfirmation":1,"saveLabel":1,"saveTemplate":1,"settings":1,"shapes":1,"shiftedVertical":1,"smallPage":1,"textTool":1,"topRuler":1,"troubleShooting":1,"uploadArt":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "css/" + ({"alignmentWizard~printPreview":"alignmentWizard~printPreview","alignmentWizard":"alignmentWizard","printPreview":"printPreview","background":"background","clipArt":"clipArt","colorPickr":"colorPickr","confirmBack":"confirmBack","contact":"contact","customLabelSizes":"customLabelSizes","forgotPassword":"forgotPassword","guideLines":"guideLines","help":"help","labelMaterials":"labelMaterials","labelShapes":"labelShapes","labelSizes":"labelSizes","layout":"layout","leftRuler":"leftRuler","loginModal":"loginModal","mismatched":"mismatched","nameAndContinue":"nameAndContinue","printOptions":"printOptions","printingCompleted":"printingCompleted","printingHelp":"printingHelp","rotate":"rotate","saveConfirmation":"saveConfirmation","saveLabel":"saveLabel","saveTemplate":"saveTemplate","settings":"settings","shapes":"shapes","shiftedVertical":"shiftedVertical","smallPage":"smallPage","textTool":"textTool","topRuler":"topRuler","troubleShooting":"troubleShooting","uploadArt":"uploadArt"}[chunkId]||chunkId) + "." + {"alignmentWizard~printPreview":"31d6cfe0","alignmentWizard":"20eacac4","printPreview":"5a1cc337","background":"8b7c5be8","clipArt":"1fa842a4","colorPickr":"999c569b","confirmBack":"70fd4781","contact":"df5c279c","customLabelSizes":"7f784ff4","forgotPassword":"de664ea6","guideLines":"18a7a369","help":"6ffe17b9","labelMaterials":"254b121f","labelShapes":"ddf215ad","labelSizes":"338444dc","layout":"350deaec","leftRuler":"6e169259","loginModal":"fb4024ae","mismatched":"f3044b61","nameAndContinue":"33a0054e","printOptions":"cffe73f9","printingCompleted":"62ea7f4b","printingHelp":"6d735ae3","rotate":"050dddf1","saveConfirmation":"68d06856","saveLabel":"2a29aca3","saveTemplate":"851d92f5","settings":"4dc3ba0f","shapes":"684f5687","shiftedVertical":"26ada578","smallPage":"a745391a","textTool":"79d91f7d","topRuler":"e3e1481f","troubleShooting":"c844076e","uploadArt":"3b5e7879"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/resources/editorvue/dist/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([0,"fontAwesome","fabric"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
